/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useRef } from 'react';
import { useSelector } from 'react-redux';
import Select from '@mui/material/Select';
import { TextField, FormControl, Grid, Button, MenuItem, Menu, Fade, Icon, CircularProgress, Box, Modal} from '@mui/material';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import { useParams, useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import Cookies from 'js-cookie';
import Typography from '@mui/material/Typography';
import { savePreviewPublish } from '../../redux/Actions/createConfigScreen.action';
import store from '../../redux/store';
import 'react-toastify/dist/ReactToastify.css';
import uploadSVG from '../../assets/images/upload.svg';
import closeSVG from '../../assets/images/close-icon.svg';
import downSVG from '../../assets/images/down-arrow.svg';
import downWhiteSVG from '../../assets/images/down_white.svg';
import upWhiteSVG from '../../assets/images/up_white.svg';
import infoSVG from '../../assets/images/info.svg';

import useStyles from './styles';

export default function CreateScreen() {
    const email = Cookies.get('email');
    
    const params = useParams();
    const classes = useStyles();
    const history = useHistory();

    
    const [open, setOpen] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);
    const [screenNames, setScreenNames] = useState([]);
    const [isNameValid, setIsNameValid] = useState(true);
    const [isBgImageValid, setIsBgImageValid] = useState(true);
    const [isFormComplete, setIsFormComplete] = useState(false);
    const [operationCall, setOperationCall] = useState({ status: false, type: ''});
    const [mainImageName, setMainImageName] = useState('');
    const [bgImageName, setBgImageName] = useState('');
    const [successToast, setSuccessToast] = useState(false);
    const [failToast, setFailToast] = useState(false);
    const [isMainImageValid, setIsMainImageValid] = useState(true);
    const [loadingOperation, setLoadingOperation] = useState(false);
    const [showInfoBg, setShowInfoBg] = useState(false);
    const [showInfoMain, setShowInfoMain] = useState(false);
    const svgInputBg = useRef(null);
    const svgInputMain = useRef(null);
    const [formInfo, setFormInfo] = useState({
        name: '',
        product: 'default',
        bgImage: null,
        bgImageName: '',
        bgImageUrl: null,
        mainImage: null,
        mainImageName: '',
        mainImageUrl: null,
        email
    });
    const { feature6Url } = useSelector((state) => state.constants.settings);

    const openDraft = Boolean(anchorEl);
    const handleClickDraft = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleCloseDraft = () => {
        setAnchorEl(null);
    };

    const handleClose = () => setOpen(false);

    const openNewTab = () => {
        window.open(feature6Url);
    };


    const setDefaultScreen = () => {
        localStorage.clear();
        const screenState = store.getState().customScreensReducer;
        // if(screenState.allScreens.length === 0) {
        //     history.push('/app/custom-screens');
        //     return;
        // }
        const loginScreens = screenState.allScreens;
        let allScreenNames = screenState.allNames;
        setScreenNames(allScreenNames);
        if (params && params.id !== undefined) {
            const screen = loginScreens.filter((screen) => screen._id === params.id);
            const bgImgName = screen[0].bgImgName.split('-#&#-');
            const mainImgName = screen[0].mainImgName.split('-#&#-');
            const { protocol, host} = window.location;
            const defaultInfo = {
                name: screen[0].name,
                product: screen[0].product,
                bgImage: null,
                bgImageName: `${bgImgName[0]}.svg`,
                bgImageUrl: `${protocol}//${host}${screen[0].bgImgNamePath}`,
                mainImage: null,
                mainImageName: `${mainImgName[0]}.svg`,
                mainImageUrl: `${protocol}//${host}${screen[0].mainImgNamePath}`,
                email: screen[0].emailId
            };
            setMainImageName(`${mainImgName[0]}.svg`);
            setBgImageName(`${bgImgName[0]}.svg`);
            allScreenNames = allScreenNames.filter((name) => name !== screen[0].name);
            setScreenNames(allScreenNames);
            setIsFormComplete(true);
            setFormInfo(defaultInfo);
            localStorage.setItem('formInfo', JSON.stringify(defaultInfo));
        }
    };

    const saveAndPreview = async () => {
        setIsFormComplete(false);
        setLoadingOperation(true);
        setOpen(true);
        const formData = new FormData();
        formData.append('name', formInfo.name);
        formData.append('product', formInfo.product);
        if(formInfo.bgImage !== null) formData.append('backgroundImage', formInfo.bgImage, formInfo.bgImage.name);
        if(formInfo.mainImage !== null) formData.append('mainImage', formInfo.mainImage, formInfo.mainImage.name);
        formData.append('emailId', formInfo.email);
        formData.append('event', true);
        formData.append('action', 'draft-preview');
        if(params && params.id) formData.append('objectId', params.id);

        try {
            setOperationCall({ status: true, type: 'preview'});
            const response =  await savePreviewPublish(formData);
            if(response.code === 200 ) {
                setSuccessToast(!successToast)
                setLoadingOperation(false);
                openNewTab();
                history.push('/app/custom-screens');
            }
        } catch (error) {
            console.error('Unable to Save Screen', error);
            setFailToast(!failToast);
            setLoadingOperation(false);
            setOpen(false)
            history.push('/app/custom-screens');
        }
    };

    const publishScreen = async () => {
        setLoadingOperation(true);
        const formData = new FormData();
        formData.append('name', formInfo.name);
        formData.append('product', formInfo.product);
        if(formInfo.bgImage !== null) formData.append('backgroundImage', formInfo.bgImage, formInfo.bgImage.name);
        if(formInfo.mainImage !== null) formData.append('mainImage', formInfo.mainImage, formInfo.mainImage.name);
        formData.append('emailId', formInfo.email);
        formData.append('event', true);
        formData.append('action', 'publish');
        if(params && params.id) formData.append('objectId', params.id);

        try {
            setOperationCall({ status: true, type: 'publish'});
            const response = await savePreviewPublish(formData);
            if(response.code === 200 ) {
                setSuccessToast(!successToast);
                setLoadingOperation(false);
                setOpen(false);
                history.push('/app/custom-screens');
            }
        } catch (error) {
            setFailToast(!failToast);
            setLoadingOperation(false);
            setOpen(false)
            history.push('/app/custom-screens');
        }
    };

    const saveAsDraft = async () => {
        setOpen(true);
        setLoadingOperation(true);
        const formData = new FormData();
        formData.append('name', formInfo.name);
        formData.append('product', formInfo.product);
        if(formInfo.bgImage !== null) formData.append('backgroundImage', formInfo.bgImage, formInfo.bgImage.name);
        if(formInfo.mainImage !== null) formData.append('mainImage', formInfo.mainImage, formInfo.mainImage.name);
        formData.append('emailId', formInfo.email);
        formData.append('event', true);
        formData.append('action', 'draft');
        if(params && params.id) formData.append('objectId', params.id);

        try {
            setOperationCall({ status: true, type: 'preview'});
            const response = await savePreviewPublish(formData);
            if (response.code=== 200) {
                setSuccessToast(!successToast)
                setLoadingOperation(false);
                setOpen(false);
                history.push('/app/custom-screens');
            }
        } catch (error) {
            console.error('Unable to Save Screen', error);
            setFailToast(!failToast);
            setLoadingOperation(false);
            setOpen(false)
            history.push('/app/custom-screens');
        }
        setAnchorEl(null);
    };

    const checkFormInfo = () => {
        if (
            formInfo.name === '' ||
            formInfo.product === 'default' ||
            formInfo.bgImageName === '' ||
            formInfo.mainImageName === '' ||
            isNameValid === false
        ) {
            setIsFormComplete(false);
            return;
        }
        setIsFormComplete(true);
    };

    const validateName = (e) => {
        setFormInfo({
            ...formInfo,
            name: e.target.value
        });
        if (screenNames.includes(e.target.value)) {
            setIsNameValid(false);
        } else {
            setIsNameValid(true);
        }

    };

    const handleProduct = (e) => {
        setFormInfo({
            ...formInfo,
            product: e.target.value
        });
    };

    const handleFileUploadMain = async (event) => {
        const fileList = event.target.files;
        const file = fileList[0];
        if (file) {
            if (file.type === 'image/svg+xml') {
                setMainImageName(file.name);
                setFormInfo({
                    ...formInfo,
                    mainImage: file,
                    mainImageName: file.name,
                    mainImageUrl: null
                });
                setIsMainImageValid(true);
            } else {
                setMainImageName(file.name);
                setIsMainImageValid(false);
                setIsFormComplete(false);
            }
        }
    };

    const handleFileUploadBg = async (event) => {
        const fileList = event.target.files;
        const file = fileList[0];
        if(file) {
            if (file.type === 'image/svg+xml') {
                setBgImageName(file.name);
                setFormInfo({
                    ...formInfo,
                    bgImage: file,
                    bgImageName: file.name,
                    bgImageUrl: null
                });
                setIsBgImageValid(true);
            } else {
                setBgImageName(file.name);
                setIsBgImageValid(false);
                setIsFormComplete(false);
            }
        }
    };

    const handleCrossMainImg = () => {
        setMainImageName('');
        setFormInfo({
            ...formInfo,
            mainImage: null,
            mainImageName: '',
            mainImageUrl: null
        });
        setIsMainImageValid(true);
    }

    const handleCrossBgImg = async () => {
        setBgImageName('');
        setFormInfo({
            ...formInfo,
            bgImage: null,
            bgImageName: '',
            bgImageUrl: null
        });
        setIsBgImageValid(true);
    }

    const svgDownIcon = ( 
        <Icon className={classes.svgButtons}>
            <img alt="preview" src={downSVG} style={{ position: 'absolute', right: '14px', top: '14px'}}/>
        </Icon>
    )

    const svgUpWhiteIcon = (
        openDraft ? 
        <Icon className={classes.svgButtons}>
            <img alt="preview" src={upWhiteSVG} style={{ margin: 'auto auto', position: 'absolute', right: '14px', top: '14px'}}/>
        </Icon> :
        <Icon>
        <img alt="preview" src={downWhiteSVG} style={{ margin: 'auto auto', position: 'absolute', right: '14px', top: '14px'}}/>
        </Icon>
        
    )

    const mainImageUploadStyle = (isMainImageValid ? 
            { 
                style: { 
                    color: '#4E4E4E',
                    fontFamily: "Montserrat",
                    fontSize: '14px',
                    textDecoration: 'underline',
                    maxWidth: 'calc(100% - 84px)'
                },
                shrink: false
            } : 
            { 
                style: { 
                    color: '#d32f2f', 
                    fontFamily: "Montserrat", 
                    fontSize: '14px', 
                    textDecoration: 'underline',
                    maxWidth: 'calc(100% - 84px)'
                },
                shrink: false
            });

    const bgImageUploadStyle = (isBgImageValid ? 
            { 
                style: { 
                    color: '#4E4E4E',
                    fontFamily: "Montserrat",
                    fontSize: '14px',
                    textDecoration: 'underline',
                    maxWidth: 'calc(100% - 84px)'
                },
                shrink: false
            } : 
            { 
                style: { 
                    color: '#d32f2f', 
                    fontFamily: "Montserrat", 
                    fontSize: '14px', 
                    textDecoration: 'underline',
                    maxWidth: 'calc(100% - 84px)'
                },
                shrink: false
            });



    useEffect(() => {
        checkFormInfo();
    }, [formInfo]);

    useEffect(() => {
        if(operationCall.status) {
            if(operationCall.type === 'publish'){
                toast.success('Image Published Successfully');
            }
            if(operationCall.type === 'preview'){
                toast.success('Login Image Saved Successfully');
            }
            setOperationCall({ status: false, type: ''});
        }
    }, [successToast]);

    useEffect(() => {
        if(operationCall.status) {
            if(operationCall.type === 'publish'){
                toast.error('Error While Publishing Image');
            }
            if(operationCall.type === 'preview'){
                toast.error('Error While Previewing Image');
            }
            setOperationCall({ status: false, type: ''});
        }
    }, [failToast]);

    useEffect(() => {
        setDefaultScreen();
    }, []);

    return (
        <div className={classes.createScreenContainer}>
            <div>
                <Modal
                    open={open}
                    onClose={handleClose}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box
                        sx={ loadingOperation ? {
                            position: 'absolute',
                            top: '50%',
                            left: '50%',
                            transform: 'translate(-50%, -50%)',
                            width: 'fit-content',
                            p: 4
                        } :{
                            padding: '10% 20%',
                            position: 'absolute',
                            top: '50%',
                            left: '50%',
                            transform: 'translate(-50%, -50%)',
                            width: 500,
                            bgcolor: 'background.paper',
                            borderRadius: '10px',
                            boxShadow: 24,
                            p: 4
                        }}
                    >
                        { loadingOperation ? 
                            <>
                            <div style={{ margin: "auto", width: 'fit-content'}}>
                                <CircularProgress />
                            </div>
                            <p style={{ color: 'white', fontFamily: 'Montserrat', fontWeight: 'bold'}}>Please Wait...</p>
                            </>:
                            <>
                                <Typography 
                                    id="modal-modal-title" 
                                    variant="h6" 
                                    component="h2" 
                                    sx={{ 
                                        fontFamily: "Montserrat",
                                        textAlign: "center",
                                        color: "#666666",
                                        fontWeight: "bold",
                                        fontSize: "16px"
                                    }}>
                                    Are you sure you want to publish
                                    <br /> 
                                    this login screen?
                                </Typography>
                                <Typography 
                                id="modal-modal-description" 
                                sx={{ 
                                    mt: 2,
                                    textAlign: "center !important",
                                    fontFamily: "Montserrat",
                                    color: "#6F96F9",
                                    fontWeight: "bold"
                                }}>
                                    {formInfo.product}
                                </Typography>
                                <div style={{ position: "relative", marginTop: "35px", marginBottom: "55px"}}>
                                    <div 
                                        style={{ 
                                            position: "absolute",
                                            top: "60%",
                                            left: "50%",
                                            transform: "translate(-50%, -50%)"
                                        }}
                                    >
                                        <Button
                                            side="medium"
                                            variant="outlined"
                                            onClick={() => setOpen(false)}
                                            sx={{
                                                boxShadow: 0,
                                                borderRadius: '4px',
                                                marginRight: "10px",
                                                marginLeft: "auto"
                                            }}
                                        >
                                            {' '}
                                            Cancel{' '}
                                        </Button>
                                        <Button
                                            size="medium"
                                            variant="outlined"
                                            onClick={publishScreen}
                                            sx={{
                                                boxShadow: 0,
                                                borderRadius: '4px'
                                            }}
                                        >
                                            Publish
                                        </Button>
                                    </div>
                                </div>
                            </>
                        }
                    </Box>
                </Modal>
            </div>
            <h1>Customize Login Screen</h1>
            <div className={classes.formContainer}>
                <div>
                    <Grid container>
                        <Grid item xs={12} sm={6}>
                            <div className={classes.inputHead}>Name*</div>
                            <FormControl fullWidth sx={{ m: 1 }} className={classes.fieldPadding}>
                                <TextField
                                    error = {isNameValid === false}
                                    id="outlined-basic"
                                    variant="outlined"
                                    label={formInfo.name === "" ? "Enter Name" : "" }
                                    value={formInfo.name}
                                    helperText= { isNameValid ? '' : 'Name Already Exists'}
                                    onChange={(e) => {
                                        validateName(e);
                                    }}
                                    InputProps={
                                        {style: formInfo.name ==="" ?
                                        { color: '#4E4E4E', fontFamily: "Montserrat", fontSize: '14px', opacity: '0.32'} :
                                        { color: '#4E4E4E', fontFamily: "Montserrat", fontSize: '14px', border: '1px solid #E9EBF0'}
                                    }}
                                    InputLabelProps={{
                                        style: { color: '#4E4E4E', fontFamily: "Montserrat", fontSize: '14px', opacity: '0.32'  },
                                        shrink: false
                                      }}
                                />
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <div className={classes.inputHead}>Choose Product*</div>
                            <FormControl fullWidth sx={{ m: 1 }} className={classes.fieldPadding}>
                                <Select
                                    labelId="demo-simple-select-autowidth-label"
                                    id="demo-simple-select-autowidth"
                                    value={formInfo.product}
                                    onChange={(e) => handleProduct(e)}
                                    sx={
                                        formInfo.product === 'default' ?
                                        { color: '#4E4E4E', fontFamily: 'Montserrat', opacity: '0.32'} :
                                        { color: '#4E4E4E', fontFamily: 'Montserrat'}
                                    }
                                >
                                    <MenuItem disabled value="default" sx={{ display: 'none' }}>
                                        Choose Product
                                    </MenuItem>
                                    <MenuItem value="SearchUnify">SearchUnify</MenuItem>
                                    {/* <MenuItem value="SUVA">SUVA</MenuItem> */}
                                    {/* <MenuItem value="Knowbler">Knowbler</MenuItem> */}
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <div className={classes.inputHead}>
                                <div style={{ width: 'fit-content', float: 'left'}}>
                                Upload Background Image*
                                <img 
                                    alt="preview" 
                                    src={infoSVG} 
                                    style={{ width: '1.1em', marginLeft: '3px', position: 'relative'}} 
                                    onMouseOver={() =>  setShowInfoBg(true)}
                                    onFocus={ () => setShowInfoBg(true)}
                                    onMouseOut={() => setShowInfoBg(false)}
                                    onBlur={() => setShowInfoBg(false)}
                                />
                                </div>
                                { showInfoBg ? <div style={{
                                    width: 'fit-content',
                                    backgroundColor: "#55C7FF",
                                    float: 'right',
                                    color: 'white',
                                    paddingLeft: '3px',
                                    paddingRight: '3px',
                                    borderRadius: '3px',
                                    marginLeft: '4px',
                                    fontWeight: '500'
                                }}>
                                    Use SVG as a file format
                                </div> : <></> }
                            </div>
                            <FormControl fullWidth sx={{ m: 1 }} className={classes.fieldPadding}>
                                <TextField
                                    error={ isBgImageValid === false}
                                    type="file"
                                    label={ bgImageName === '' ? "Upload Image" : bgImageName}
                                    onChange={handleFileUploadBg}
                                    fullWidth
                                    sx={bgImageName === '' ? { opacity: '0.32'} : {}}
                                    helperText = { isBgImageValid ? '' : 'Wrong File Format'}
                                    inputProps={{ accept: 'image/*', ref: svgInputBg, style: { opacity: '0', cursor: 'pointer'} }}
                                    InputLabelProps={
                                    bgImageName === '' ? { 
                                        style: { color: '#4E4E4E', fontFamily: "Montserrat", fontSize: '14px' },
                                        shrink: false
                                    } : bgImageUploadStyle}
                                />
                                {bgImageName !== '' ? (
                                    <>
                                        <div style={
                                            { 
                                                position: 'absolute',
                                                zIndex: '999', 
                                                top: '17px', 
                                                left: '10px',  
                                                color: '#4E4E4E', 
                                                fontFamily: "Montserrat", 
                                                fontSize: '14px', 
                                                width: 'fit-content',
                                                maxWidth: 'calc(100% - 94px)'
                                            }}>
                                            <a href={formInfo.bgImageUrl} style={{ color: '#4E4E4E'}} target='_blank' rel="noreferrer">
                                                <span style={{ opacity: '0'}}>{bgImageName}</span>
                                            </a>
                                        </div>
                                        <div style={{ position: 'absolute', zIndex: '999', right: '138px', top: '17px' }}>
                                        <button onClick={handleCrossBgImg} style={{ background: 'none', border: '0', cursor: 'pointer' }}><img alt="preview" src={closeSVG} /></button>
                                        </div>
                                    </>
                                ) : ( <> </> )}
                                <button onClick={()=>svgInputBg.current.click()} style={{ position: 'absolute',zIndex: '999', right: '110px', top: '14px', cursor: 'pointer', background: 'transparent', border: '0px'}}>
                                <img alt="preview" src={uploadSVG} style={{ cursor: 'pointer'}} />
                                </button>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <div className={classes.inputHead}>
                                <div style={{ width: 'fit-content', float: 'left'}}>
                                    Upload Main Image* 
                                    <img 
                                        alt="preview" 
                                        src={infoSVG}
                                        onMouseOver={() =>  setShowInfoMain(true)}
                                        onFocus={ () => setShowInfoMain(true)}
                                        onMouseOut={() => setShowInfoMain(false)}
                                        onBlur={() => setShowInfoMain(false)}
                                        style={{ width: '1.1em', marginLeft: '3px', position: 'relative'}} />
                                </div>
                                { showInfoMain ? 
                                 <div style={{
                                    width: 'fit-content',
                                    backgroundColor: "#55C7FF",
                                    float: 'right',
                                    color: 'white',
                                    paddingLeft: '3px',
                                    paddingRight: '3px',
                                    borderRadius: '3px',
                                    marginLeft: '4px',
                                    fontWeight: '500'
                                }}>
                                    Use SVG as a file format
                                </div> : <> </> }
                            </div>
                            <FormControl fullWidth sx={{ m: 1}} className={classes.fieldPadding}>
                                <TextField
                                    error={isMainImageValid === false}
                                    label={ mainImageName === '' ? 'Drag or Upload Image' : mainImageName }
                                    type="file"
                                    onChange={handleFileUploadMain}
                                    fullWidth
                                    sx={mainImageName === '' ? { opacity: '0.32'} : {}}
                                    helperText = { isMainImageValid ? '' : 'Wrong File Format'}
                                    inputProps={{ accept: 'image/*', ref: svgInputMain, style: {opacity: '0', cursor: 'pointer' } }}
                                    InputLabelProps={
                                    mainImageName === '' ? {
                                        style: { color: '#4E4E4E', fontFamily: "Montserrat", fontSize: '14px'},
                                        shrink: false
                                    }: mainImageUploadStyle}
                                />
                                {mainImageName !== '' ? (
                                    <>
                                        <div style={{ position: 'absolute', zIndex: '999', left: '10px', top: '17px', color: '#4E4E4E', fontFamily: "Montserrat", fontSize: '14px', width: 'fit-content'}}>
                                            <a href={formInfo.mainImageUrl} style={{ color: '#4E4E4E'}} target='_blank' rel="noreferrer">
                                            <span style={{ opacity: '0'}}>{mainImageName}</span>
                                            </a>
                                        </div>
                                        <div style={{ position: 'absolute', zIndex: '999', right: '138px', top: '17px' }}>
                                            <button onClick={handleCrossMainImg} style={{ background: 'none', border: '0', cursor: 'pointer'}}><img alt="preview" src={closeSVG} /></button>
                                        </div>
                                    </>
                                ) : ( <> </> )}
                                <button onClick={()=>svgInputMain.current.click()} style={{ position: 'absolute',zIndex: '999', right: '110px', top: '14px',  cursor: 'pointer', background: 'transparent', border: '0px'}}>
                                    <img alt="preview" src={uploadSVG}/>
                                </button>
                            </FormControl>
                        </Grid>
                    </Grid>
                </div>
                <div style={{ marginTop: '20px'}}>
                    <Button
                    variant="contained"
                    disabled={!isFormComplete}
                    id="fade-button"
                    className={classes.dropButton}
                    aria-controls={openDraft ? 'fade-menu' : undefined}
                    aria-haspopup="true"
                    aria-expanded={openDraft ? 'true' : undefined}
                    onClick={handleClickDraft}
                    startIcon={isFormComplete === false ? svgDownIcon : svgUpWhiteIcon}
                    sx={{
                        boxShadow: 0,
                        borderRadius: '0',
                        marginRight: '7.8%',
                        minWidth: '34px',
                        padding: '7.2px 10px',
                        backgroundColor: '#598ADC'
                    }}
                    />
                    <Menu
                        id="fade-menu"
                        MenuListProps={{
                            'aria-labelledby': 'fade-button',
                        }}
                        anchorEl={anchorEl}
                        open={openDraft}
                        onClose={handleCloseDraft}
                        TransitionComponent={Fade}
                        sx={{
                            '& .MuiPaper-root' : {
                                minWidth: '134px !important',
                                boxShadow: '0px 3px 6px #00000029 !important'
                            }
                        }}
                    >
                        <MenuItem onClick={saveAsDraft} sx={{ boxShadow: '0'}}>Save As Draft</MenuItem>
                    </Menu>
                    <Button
                        size="medium"
                        variant="contained"
                        onClick={() => setOpen(true)}
                        disabled={!isFormComplete}
                        sx={{
                            boxShadow: 0,
                            minWidth: '94px',
                            backgroundColor: '#6F96F9',
                            fontFamily: 'OpenSans',
                            fontWidth: 'bold',
                            paddingLeft: '1px',
                            borderTopRightRadius: '0px',
                            borderBottomRightRadius: '0px',
                        }}
                        className={classes.savePreviewPublishButton}
                    >
                        Publish
                    </Button>
                    <Button
                        size="medium"
                        disabled={!isFormComplete}
                        sx={{
                            boxShadow: 0,
                            marginRight: '10px',
                            fontFamily: 'OpenSans',
                            fontWidth: 'bold'
                        }}
                        variant={isFormComplete ? 'outlined' : 'contained'}
                        className={classes.savePreviewPublishButton}
                        onClick={saveAndPreview}
                    >
                        Save & Preview
                    </Button>
                    <Button
                        size="medium"
                        component={Link}
                        to="/app/custom-screens"
                        variant="outlined"
                        className={classes.cancelButton}
                        style={{
                            minWidth: '90px',
                            float: 'right',
                            marginRight: '1%',
                            borderRadius: '3px',
                            fontFamily: 'OpenSans',
                            fontWidth: 'semi',
                            textTransform: 'none'
                        }}
                    >
                            Cancel
                    </Button>
                </div>
            </div>
        </div>
    );
}
